import React from "react";

import { legendItemStyle, legendStyle } from "./style";
import { greenCyan, darkPurple } from "../util/colors";
import {
  depthNamesSorted,
  depthColorsDict,
  removeSubstringFloodDepth,
} from "../emergencyMonitoring/eventDetails/floodDepthUtils";

export const EmergencyMonitoringLegend = ({
  customLegendStyle = legendStyle,
  showDamagedBuildings = false,
}) => {
  const legendForClaims = (
    <div>
      <div>
        <span style={legendItemStyle(greenCyan)}></span>Policies in the monitored area
      </div>
      <div>
        <span style={legendItemStyle(darkPurple)}></span>Policies in the affected area
      </div>
      <div>
        <span style={legendItemStyle("orange")}></span>Claims in the monitored area
      </div>
      <div>
        <span style={legendItemStyle("red")}></span>Claims in the affected area
      </div>
    </div>
  );

  const legendForBuiltUpGeojson = (
    <div>
      <div>
        <span style={legendItemStyle("yellow")}></span>Possibly damaged
      </div>
      <div>
        <span style={legendItemStyle("orange")}></span>Damaged
      </div>
      <div>
        <span style={legendItemStyle("red")}></span>Destroyed
      </div>
    </div>
  );

  return (
    <div style={customLegendStyle}>
      <div>
        <b>Emergency Monitoring</b>
      </div>

      {showDamagedBuildings ? legendForBuiltUpGeojson : legendForClaims}

      <div>
        <span style={legendItemStyle("#48c6ff")}></span>Flood affected area
      </div>

      <div>
        <b>Maximum observed flood depth (if available)</b>{" "}
      </div>
      {depthNamesSorted.map((depthName, index) => (
        <div key={index}>
          <span style={legendItemStyle(depthColorsDict[depthName])}></span>
          Flood depth {removeSubstringFloodDepth(depthName)}
        </div>
      ))}

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          Data processed by CyStellar
        </span>
      </div>
    </div>
  );
};
